import { Link } from 'react-router-dom';
import { User as UserIcon } from 'lucide-react';
import { useSessionStore } from '@/stores/session';
import { cn } from '@/lib/utils';

function getInitials(name?: string): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function HeaderProfile() {
  const user = useSessionStore((s) => s.user);
  return (
    <Link
      to="/profile"
      title={user?.name ? `${user.name} (${user.email})` : 'Perfil'}
      className={cn(
        'inline-flex items-center gap-2 rounded-full border border-border bg-card pl-1 pr-3 py-1',
        'text-xs font-semibold transition-colors hover:bg-accent',
      )}
    >
      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-gradient-to-br from-primary to-purple-500 text-white">
        {user?.name ? (
          <span className="text-[11px] font-bold">{getInitials(user.name)}</span>
        ) : (
          <UserIcon className="h-3.5 w-3.5" />
        )}
      </span>
      <span className="hidden max-w-[140px] truncate sm:inline">
        {user?.name ?? 'Perfil'}
      </span>
    </Link>
  );
}
